import { auth } from '@/firebase/auth'
import { onAuthStateChanged, signOut, signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword } from 'firebase/auth'

export const authService = {
  getCurrentUser() {
    return auth.currentUser
  },

  onAuthStateChanged(callback) {
    return onAuthStateChanged(auth, callback)
  },

  async logout() {
    await signOut(auth)
  },

  async loginWithEmail(email, password) {
      return signInWithEmailAndPassword(auth, email, password)
  },
  
  // Future proofing: login methods
  async loginWithGoogle() {
      const provider = new GoogleAuthProvider()
      return signInWithPopup(auth, provider)
  }
}
